export default "__VITE_ASSET__d4f27403__"